module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "text-center col-xs-12",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "social-icons-container"
  }, [_c('a', {
    staticClass: "social-icon gtm_socialiconCX2",
    attrs: {
      "href": "https://www.facebook.com/MarcusThomasCLE/",
      "target": "_blank",
      "title": "Go to Marcus Thomas's Facebook"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "social-icon gtm_socialiconCX2",
    attrs: {
      "href": "https://twitter.com/MarcusThomasCle",
      "target": "_blank",
      "title": "Go to Marcus Thomas's Twitter"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "social-icon gtm_socialiconCX2",
    attrs: {
      "href": "https://www.linkedin.com/company/marcus-thomas-llc?trk=top_nav_home",
      "target": "_blank",
      "title": "Go to Marcus Thomas's Linked In"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "social-icon gtm_socialiconCX2",
    attrs: {
      "href": "https://www.instagram.com/marcusthomasllc/",
      "target": "_blank",
      "title": "Go to Marcus Thomas's Instagram"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "social-copy"
  }, [_c('p', {
    staticClass: "strech"
  }, [_vm._v("\n      Marcus Thomas LLC, with nearly 300 professionals in its offices in\n      Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago,\n      Chile, is among America’s leading independent, full-service, integrated\n      advertising agencies. Marcus Thomas is a recognized leader in creative,\n      media, public relations, social media, digital strategy and technology.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": '/terms'
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" |\n      "), _c('router-link', {
    attrs: {
      "to": '/privacy'
    }
  }, [_vm._v("Privacy Policy")])], 1)]), _vm._v(" "), _c('cookie-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      © Marcus Thomas LLC | Cleveland + Cincinnati + Buenos Aires +\n      Santiago"), _c('br'), _vm._v("4781 Richmond Road Cleveland, Ohio 44128 (216) 292.4700\n      (888) 482.4455\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6856b64e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/footer-component.vue
// module id = 1535
// module chunks = 0